import { Component, Input, OnInit } from '@angular/core';
import { Partner, IonicColorEnum } from '@mlc/types';

@Component({
    selector: 'app-contact-card',
    templateUrl: './contact-card.component.html',
    styleUrls: ['./contact-card.component.scss'],
    standalone: false
})
export class ContactCardComponent {
  @Input({ required: true }) partner!: Partner;
  @Input() hideTitle: boolean = false;

  protected readonly IonicColorEnum = IonicColorEnum;
}
